import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import React, { useRef, useEffect } from 'react';

import landingPageTheme from '@/@mantis/theme/landingPageTheme';
import '@/styles/landingPage.css';

import FooterSection from './sections/FooterSection';
import NavSection from './sections/NavSection';
import PMSecuritySection from './sections/PMSecuritySection';
import VendorHowItWorksSection from './sections/VendorHowItWorksSection';
import VendorSearchSection from './sections/VendorSearchSection';

// Custom wrapper for the property management landing page
const PMLandingPageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Create a theme instance specifically for the landing page
  const theme = createTheme(landingPageTheme);

  // Add preload link for Nohemi font to improve loading on mobile
  useEffect(() => {
    const fontPreloadLinks = [
      { href: '/assets/fonts/Nohemi-Regular.woff2', type: 'font/woff2' },
      { href: '/assets/fonts/Nohemi-SemiBold.woff', type: 'font/woff' },
    ];

    fontPreloadLinks.forEach(font => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = font.href;
      link.as = 'font';
      link.type = font.type;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    return () => {
      fontPreloadLinks.forEach(font => {
        const links = document.querySelectorAll(`link[href="${font.href}"]`);
        links.forEach(link => link.remove());
      });
    };
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>{children}</div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const PropertyManagementLandingPage: React.FC = () => {
  // const featuresRef = useRef<HTMLDivElement>(null);
  const securityRef = useRef<HTMLDivElement>(null);
  const campaign = 'property_owner';

  useEffect(() => {
    localStorage.setItem('campaign', campaign);
  }, []);

  // const scrollToFeatures = () => {
  //   if (featuresRef.current) {
  //     featuresRef.current.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };

  // const scrollToSecurity = () => {
  //   if (securityRef.current) {
  //     securityRef.current.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };

  return (
    <PMLandingPageWrapper>
      <NavSection simplified campaign={campaign} />
      <VendorSearchSection />
      <VendorHowItWorksSection />
      {/* <PMHeroSection
        scrollToFeatures={scrollToFeatures}
        scrollToSecurity={scrollToSecurity}
        campaign={campaign}
      />
      <PMFeaturesSection ref={featuresRef} />
      <PMBenefitsSection /> */}
      <PMSecuritySection ref={securityRef} />
      <FooterSection />
    </PMLandingPageWrapper>
  );
};

export default PropertyManagementLandingPage;
